import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: import.meta.env.VITE_REACT_APP_HOSTNAME,
    realm: "quanterix",
    clientId: "quanterix-simoa-one",
})

export default keycloak;